import React, { useEffect, useState } from 'react';
import { clsx } from 'clsx';
import GradeStamp, { GradeStampSize } from './GradeStamp';
import { LetterGrade } from '../../utils/gradeEngine';

interface GradingLoaderProps {
  /** Caption under the stamp, e.g. "Grading the season…" */
  label?: string;
  size?: GradeStampSize;
  className?: string;
}

// The stamp works its way up the report card while we compute
const CYCLE: LetterGrade[] = ['F', 'D', 'C', 'B', 'A', 'A+'];
const CYCLE_MS = 550;

/**
 * Branded loading state: a grade stamp re-stamping through the letter
 * scale while the verdict is computed. Replaces generic spinners —
 * perpetual micro-loop, transform/opacity only.
 */
const GradingLoader: React.FC<GradingLoaderProps> = ({
  label = 'Grading…',
  size = 'md',
  className,
}) => {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return; // hold a static stamp instead of cycling
    }
    const id = setInterval(() => setTick((t) => t + 1), CYCLE_MS);
    return () => clearInterval(id);
  }, []);

  const grade = CYCLE[tick % CYCLE.length];

  return (
    <div
      className={clsx('flex flex-col items-center justify-center gap-3 py-10', className)}
      role="status"
      aria-label={label}
    >
      {/* key remounts the stamp so the stamp-in animation replays each tick */}
      <GradeStamp key={tick} grade={grade} size={size} animate />
      <p className="font-mono text-sm text-text-secondary tracking-wide">{label}</p>
    </div>
  );
};

export default GradingLoader;
